import { createStore, compose, applyMiddleware } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers/index';
import sagas from './sagas';

const defaultState = {
	header: {
		menus: null,
	},
	locations: [{}, {}],
	cycleRoutes: {
		gotData: false
	},
	currentJourney: false,
	leisureRides: {},
	LCN: {},
	SR: {},
	SUS: {},
	POI: {
		poi: {},
		shown: window.innerWidth >= 1000,
	},
	cycleHire: {},
	filters: {
		distance: 0,
		difficulty: 0,
		type: 0,
		searchName: null
	},
	map: {
		bounds: [],
		markers: [],
		polylines: [],
		polygons: [],
		overlays: [],
	},
	errors: {},
	sidebar: {}
};

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const enhancers = composeEnhancers(applyMiddleware(sagaMiddleware));

const store = createStore(rootReducer, defaultState, enhancers);

sagaMiddleware.run(sagas);

export const history = syncHistoryWithStore(browserHistory, store);

// Enable hot reloading of reducers (normally only components)
if (module.hot) {
	module.hot.accept('./reducers/', () => {
		const nextRootReducer = require('./reducers/index').default;
		store.replaceReducer(nextRootReducer);
	});
}

export default store;



// WEBPACK FOOTER //
// ./src/store.js